<template>
    <div class="sidebar">
        <div class="side-action-panel">
            <div class="side-action-panel-title">
                マイページ
                <span class="right-arrow-icon"></span>

            </div>
            <div class="side-action-panel-actions">
                <a href="/mypage/buy_point" class="purchase-point">ポイント購入</a>
                <a href="/mypage/item" class="upload-product">出品する</a>
            </div>
        </div>

        <div class="side-categories">
          <div class="side-categories-title">
            <a>
              ジャンル
<!--              <span class="right-arrow-icon"></span>-->
            </a>
          </div>
          <a :href="item.url" v-for="item in big_category" >
            <div class="side-categories-item">
              {{ item.text }}
              <span class="right-arrow-icon"></span>
            </div>
          </a>

            <div class="side-categories-title">
                <a href="/category">
                    カテゴリー
                    <span class="right-arrow-icon"></span>
                </a>
            </div>
            <div v-for="item in category" class="side-categories-item">
                <a :href="item.url">
                    {{ item.title }}
                    <span class="right-arrow-icon"></span>
                </a>
                <div class="sub-menu">
                    <div v-for="children_item in item.details">
                        <a :href="children_item.url"><p>{{ children_item.text }}</p></a>
                    </div>
                </div>
            </div>

            <div class="side-categories-title">
                <a href="/tag">
                    人気なキーワード
                    <span class="right-arrow-icon"></span>
                </a>
            </div>
            <a :href="item.url" v-for="item in keyword" >
                <div class="side-categories-item">
                    {{ item.text }}
                    <span class="right-arrow-icon"></span>
                </div>
            </a>

        </div>
    </div>
</template>

<script>
    export default {
        props: ['bigCategories', 'categories', 'keywords'],
        data() {
            return {
                big_category: JSON.parse(this.bigCategories),
                category: JSON.parse(this.categories),
                keyword: JSON.parse(this.keywords)
            }
        },
    }
</script>

<style>
    .side-action-panel {
        background: #444444;
    }

    .side-action-panel-title {
        font-size: 14px;
        line-height: 24px;
        color: #ffffff;
        height: 40px;
        padding: 8px 27px;
        font-weight: bold;
        position: relative;
    }

    .side-action-panel-title .right-arrow-icon {
        border-right: 2px solid #ffffff;
        border-bottom: 2px solid #ffffff;
    }

    .side-action-panel-actions {
        border-top: 1px solid #808080;
        padding: 10px;
    }

    .side-action-panel-actions a {
        width: 100%;
        border-radius: 3px;
        padding: 12px 30px 12px 60px;
        font-size: 15px;
        line-height: 24px;
        display: block;
    }

    .side-action-panel-actions a + a {
        margin-top: 5px;
    }

    .side-action-panel-actions .purchase-point {
        color: white;
        background-color: #F08C1E;
        background-image: url("/images/icons/point.svg");
        background-repeat: no-repeat;
        background-size: 18px;
        background-position: 32px;
        text-decoration: none;
    }

    .side-action-panel-actions .purchase-point:hover,
    .side-action-panel-actions .purchase-point:visited {
        color: white;
        text-decoration: none;
    }

    .side-action-panel-actions .purchase-point:hover {
        opacity: 0.5;
    }

    .side-action-panel-actions .upload-product {
        color: #333333;
        background-color: #FAFAFA;
        background-image: url("/images/icons/upload.svg");
        background-repeat: no-repeat;
        background-size: 18px;
        background-position: 32px;
        text-decoration: none;
    }

    .side-action-panel-actions .upload-product:hover,
    .side-action-panel-actions .upload-product:visited {
        color: #333333;
        text-decoration: none;
    }

    .side-action-panel-actions .upload-product:hover {
        opacity: 0.5;
    }

    .side-categories a,
    .side-categories a:hover,
    .side-categories a:visited {
        color: #000;
    }

    .side-categories > .side-categories-title {
        font-size: 14px;
        line-height: 24px;

        background-color: #EFEFEF;
        height: 40px;
        padding: 8px 27px;
        font-weight: bold;
        position: relative;
    }

    .side-categories-title .right-arrow-icon {
        border-right: 2px solid #000;
        border-bottom: 2px solid #000;
    }

    .side-categories-title a,
    .side-categories-title a:hover,
    .side-categories-title a:visited {
        color: #000;
    }

    .side-categories-item {
        font-size: 14px;
        line-height: 24px;
        height: 40px;
        padding: 8px 27px;
        position: relative;
        cursor: pointer;
    }


    .side-categories-item .sub-menu {
        display: none;
        position:absolute;
        background-color:#ffffff;
        width:180px;
        top: 0;
        left: 100%;
        border-radius: 3px;
        border: 1px solid #EFEFEF;
        box-shadow: 0 0 3px rgb(0 0 0 /20%);
        color: #000;
        z-index: 500;
        padding: 18px 0;
    }

    .side-categories-item .right-arrow-icon {
        border-right: 2px solid #969696;
        border-bottom: 2px solid #969696;
    }

    .side-categories-item:hover {
        background-color: #EFEFEF;
        text-decoration: underline;
    }

    .side-categories-item:hover a,
    .side-categories-item:hover a:hover,
    .side-categories-item:hover a:visited {
        color: #B0B0B0;
    }

    .side-categories-item .sub-menu a,
    .side-categories-item .sub-menu a:hover,
    .side-categories-item .sub-menu a:visited,
    .side-categories-item:hover .sub-menu a,
    .side-categories-item:hover .sub-menu a:hover,
    .side-categories-item:hover .sub-menu a:visited {
        color: #000;
    }

    .side-categories-item:hover .right-arrow-icon {
        border-right: 2px solid #E3E3E3;
        border-bottom: 2px solid #E3E3E3;
    }

    .side-categories-item:hover .sub-menu {
        display: block;
    }

    .side-categories-item .sub-menu p {
        font-size: 14px;
        line-height: 24px;
        padding: 2px 20px;
        margin: 0;
    }

    .side-categories-item .sub-menu p:hover {
        background-color: #EFEFEF;

        text-decoration: underline;
    }
    .side-categories-item .sub-menu p:hover a,
    .side-categories-item .sub-menu p:hover a:hover,
    .side-categories-item .sub-menu p:hover a:visited {
        color: #B0B0B0;
    }

</style>